/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import style from '../../../../../assets/styles/testCreationStyle.module.css';
import {
  Add_Section_Test,
  Edit_Section_Test,
  Get_All_Identifier,
  Validate_Section_Rule_Test,
  Get_Rule_List,
  changeAdd_test_screen,
} from '../../../../../redux/action';
import { DELETE_SECTION_RULE_SUBRULE_LIST } from '../../../../../action/apiPath';
import { useDispatch, useSelector } from 'react-redux';
import QuillEditor from '../../../../atoms/QuillEditor';
import { useToast } from '../../../common/Toast';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import ruleEdit from '../../../../../assets/images/sectionEdit.svg';
import ruleDelete from '../../../../../assets/images/sectionDelete.svg';
import BrowsingQuestionLoft from '../AddTest/BrowsingQuestionLoft';
import { CallWithAuth } from '../../../../../action/apiActions';
import { handleConfirmDuplicate } from '../../../../atoms/Modal/duplicateInPreviewHelper';
import { editQuestionHandler } from '../../../../atoms/Modal/editHandlers';
import { closePreviewModal, openPreviewModal } from '../../../../atoms/Modal/modalHandlers';
import { useNavigate } from 'react-router-dom';
import PreviewModal from '../../../../atoms/Modal/PreviewModal';
import QuestionListModal from '../../../../atoms/Modal/QuestionListModal';
import LockModal from '../../../../atoms/Modal/LockModel';
import { closeModalHelper } from '../../../../atoms/Modal/duplicateHelper';

const LoftSections = ({ isEdit, onAdd, isView, getData }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Get_All_Identifier(organizationId, '', ''));
  }, []);
  const {
    identifierList,
    testCreationId,
    replacedQuestion,
    getBasicSettingData,
    testDetails,
    validateBody,
    ruleListBody,
    deleteRuleBody,
  } = useSelector((state) => state.GetAllData);

  // FOr duplicate

  const [isPreviewopen, setIsPreviewopen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [modalMedium, setModalMedium] = useState(false);
  const [questionAccess, setQuestionAccess] = useState({});
  const [modalData, setModalData] = useState();
  const [isDuplicatePreview, setIsDuplicatePreview] = useState(false); // State to store dataToPass
  const [questionBankId, setQuestionBankId] = useState(null);
  const [questionItem, setQuestionItem] = useState({});
  const [modalModalData] = useState({
    title: 'This Question is Linked to Existing Tests',
    description:
      'The question you are about to edit has been used in one or more tests. Please be sure to click the ‘Update Exam’ button to update the changes across all tests that include this question.',
    cancelButton: 'Cancel',
    saveButton: 'Continue',
    substitle: 'Are you sure you want to proceed with editing this question?',
  });
  const onConfirmDuplicate = (questionBankId, questionId) => {
    const setactionId = null;
    const questionCategory = null;
    const QuestionListing = () => Promise.resolve(true);
    const MyQuestionListing = () => Promise.resolve(true);
    handleConfirmDuplicate(
      organizationId,
      questionBankId,
      questionId,
      setIsModalOpen,
      setIsPreviewopen,
      setIsDuplicatePreview,
      setactionId,
      toast,
      questionCategory,
      QuestionListing,
      MyQuestionListing
    );
  };
  const handleOpenModal = (items) => {
    openPreviewModal(items, setSelectedQuestion, setIsPreviewopen);
  };
  const handleCloseModal = () => {
    closePreviewModal(setIsPreviewopen, setIsDuplicatePreview, setIsModalOpen);
  };
  const navigate = useNavigate();
  const handleEdit = async (items) => {
    const updatedItems = { ...items };
    await editQuestionHandler(updatedItems, setIsPreviewopen, openModalMedium, setQuestionItem, navigate);
  };

  const openModalMedium = () => {
    setModalMedium(true);
  };
  const closeModalMedium = () => {
    setModalMedium(false);
  };
  const closeModal = () => {
    closeModalHelper(setIsModalOpen, setModalData, setIsDuplicatePreview);
  };

  useEffect(() => {
    const Permission = JSON.parse(sessionStorage.getItem('permissionForQuestions') ?? '{}');
    const newQuestionAccess = Permission?.question_bank_management?.filter((item) => item.id === questionBankId)[0];
    if (Permission && newQuestionAccess) {
      sessionStorage.setItem('questionAccess', JSON.stringify(newQuestionAccess));
      setQuestionAccess(newQuestionAccess);
    } else {
      setQuestionAccess({});
      const payload = { draft: false, edit: false, review: false, view: false, id: questionBankId };
      sessionStorage.setItem('questionAccess', JSON.stringify(payload));
    }
  }, [questionBankId]);
  // FOr duplicate
  const [body, setBody] = useState({
    groups: [
      {
        group_name: '',
        group_id: '',
        order: 1,
        randomize_sections: false,
        has_unattempted_penalty: false,
        instructions: [
          {
            has_timer: false,
            minutes: null,
            seconds: null,
            instruction_text: '',
          },
        ],
        sections: [
          {
            order: 1,
            section_name: '',
            section_id: '',
            identifier: null,
            no_of_questions: null,
            randomize_questions_within_section: false,
            correct_answer_marks:
              testDetails?.correct_answer_marks ?? getBasicSettingData?.correct_answer_marks ?? null,
            incorrect_answer_marks:
              testDetails?.incorrect_answer_marks ?? getBasicSettingData?.incorrect_answer_marks ?? null,
            section_total_question_added: 0,
            footer_selected_rules: [],
            rules: [],
          },
        ],
      },
    ],
  });
  //__________ Group -> add , remove , drag & drop __________
  const [groups, setGroups] = useState([{ id: 0, sections: [0] }]);
  const [groupsButton, setGroupsButton] = useState(0);
  const [sectionButton, setSectionButton] = useState(0);
  const [collapsedRules, setCollapsedRules] = useState({});
  const [currentDeleteRuleID, setCurrentDeleteRuleID] = useState({});
  const [testType, setTestType] = useState(testDetails?.test_type ?? 0);
  useEffect(() => {
    if (body.groups[groupsButton].sections[sectionButton] === undefined) {
      setSectionButton(body.groups[groupsButton].sections.length - 1);
    }
  }, [groupsButton]);
  const [sectionValidationBody, setSectionValidationBody] = useState(() => {
    const group = body.groups[groupsButton];
    const section = group.sections[sectionButton];
    return {
      group_name: group.group_name,
      ...(group.group_id !== '' || group.group_id != null ? { group_id: group.group_id } : {}),
      section_name: section.section_name,
      ...(section.section_id !== '' || section.section_id != null ? { section_id: section.section_id } : {}),
      no_of_questions: section.no_of_questions,
      correct_answer_marks: section.correct_answer_marks,
      incorrect_answer_marks: section.incorrect_answer_marks,
    };
  });
  useEffect(() => {
    if (deleteRuleBody) {
      if (deleteRuleBody === 1) {
        setRemoveId([]);
        const updatedBody = { ...body };
        updatedBody.groups[groupsButton].sections[sectionButton].footer_selected_rules = [];
        setBody(updatedBody);
      }
      if (deleteRuleBody === 0) {
        const footerSelectedRules = body.groups[groupsButton].sections[sectionButton].footer_selected_rules.filter(
          (rule) => !(rule.ruleId === currentDeleteRuleID.id && rule.ruleFormat === currentDeleteRuleID.format)
        );

        const updatedBody = { ...body };
        updatedBody.groups[groupsButton].sections[sectionButton].footer_selected_rules = footerSelectedRules;
        setBody(updatedBody);
      }
    }
  }, [deleteRuleBody]);
  useEffect(() => {
    if (testDetails?.test_type) {
      setTestType(testDetails?.test_type);
    }
    if (getBasicSettingData) {
      setTestType(getBasicSettingData?.test_type);
    }
  }, [getBasicSettingData, testDetails]);
  const toggleCollapse = (ruleId) => {
    setCollapsedRules((prev) => ({
      ...prev,
      [ruleId]: !prev[ruleId], // Toggle only the clicked rule's state
    }));
  };

  useEffect(() => {
    // if(body.groups[groupsButton].group_id && body.groups[groupsButton].sections[sectionButton].section_id){
    //   sectionRuleListing();
    // }
  }, []);
  useEffect(() => {
    const group = body.groups[groupsButton];
    const section = group.sections[sectionButton];
    setSectionValidationBody({
      group_name: group?.group_name ?? '',
      ...(group?.group_id !== '' ? { group_id: group?.group_id } : {}),
      section_name: section?.section_name ?? '',
      ...(section?.section_id !== '' ? { section_id: section?.section_id } : {}),
      no_of_questions: section?.no_of_questions ?? '',
      correct_answer_marks: section?.correct_answer_marks ?? '',
      incorrect_answer_marks: section?.incorrect_answer_marks ?? '',
    });
  }, [body, groupsButton, sectionButton]);
  // add group
  const addGroup = () => {
    setGroups([...groups, { id: groups.length, sections: [0] }]);

    setBody((prevBody) => ({
      ...prevBody,
      groups: [
        ...prevBody.groups,
        {
          group_name: '',
          group_id: '',
          order: groups?.length + 1,
          randomize_sections: false,
          has_unattempted_penalty: false,
          instructions: [
            {
              has_timer: false,
              minutes: null,
              seconds: null,
              instruction_text: '',
            },
          ],
          sections: [
            {
              order: sectionButton + 1,
              section_name: '',
              section_id: '',
              identifier: null,
              no_of_questions: '',
              randomize_questions_within_section: false,
              correct_answer_marks: testDetails?.correct_answer_marks ?? getBasicSettingData?.correct_answer_marks,
              incorrect_answer_marks:
                testDetails?.incorrect_answer_marks ?? getBasicSettingData?.incorrect_answer_marks,
              section_total_question_added: 0,
              footer_selected_rules: [],
              rules: [],
            },
          ],
        },
      ],
    }));
  };

  const closegroups = () => {
    if (groups.length === 1) return; // Prevent removing the last group

    setGroups((prevGroups) => {
      const updatedGroups = prevGroups.filter((_, index) => index !== groupsButton);
      return updatedGroups;
    });

    setBody((prevBody) => {
      const updatedGroups = prevBody.groups.filter((_, index) => index !== groupsButton);
      return {
        ...prevBody,
        groups: updatedGroups,
      };
    });

    // Adjust the active group index
    setGroupsButton((prev) => (prev === 0 ? 0 : prev - 1));
  };

  const addSection = (groupId) => {
    const sectionOrder = groups[groupsButton]?.sections?.length + 1;
    setGroups(
      groups.map((group) => {
        if (group.id === groupId) {
          const newSectionId = group.sections.length;
          return {
            ...group,
            sections: [...group.sections, newSectionId],
          };
        }
        return group;
      })
    );

    setBody((prevBody) => {
      return {
        ...prevBody,
        groups: prevBody.groups.map((group, index) => {
          if (index === groupId) {
            const newSection = {
              order: sectionOrder,
              section_name: '',
              identifier: null,
              no_of_questions: '',
              randomize_questions_within_section: false,
              correct_answer_marks: testDetails?.correct_answer_marks ?? getBasicSettingData?.correct_answer_marks,
              incorrect_answer_marks:
                testDetails?.incorrect_answer_marks ?? getBasicSettingData?.incorrect_answer_marks,
              section_total_question_added: 0,
              footer_selected_rules: [],
              rules: [],
            };
            return {
              ...group,
              sections: [...group.sections, newSection],
            };
          }
          return group;
        }),
      };
    });
  };

  const deleteSection = (groupId, sectionIndex) => {
    // Ensure there's more than one section before deleting
    setGroups((prevGroups) => {
      return prevGroups.map((group) => {
        if (group.id === groupId && group.sections.length > 1) {
          return {
            ...group,
            sections: group.sections.filter((_, idx) => idx !== sectionIndex),
          };
        }
        return group;
      });
    });
    setBody((prevBody) => {
      return {
        ...prevBody,
        groups: prevBody.groups.map((group, index) => {
          if (index === groupId && group.sections.length > 1) {
            const updatedSections = group.sections.filter((_, idx) => idx !== sectionIndex);
            // Recalculate the order
            updatedSections.forEach((section, idx) => {
              section.order = idx + 1;
            });
            return {
              ...group,
              sections: updatedSections,
            };
          }
          return group;
        }),
      };
    });
    // Update sectionButton if necessary
    setSectionButton((prevButton) => {
      // If the deleted section was the last one, move selection one section back.
      if (prevButton === sectionIndex && prevButton > 0) {
        return prevButton - 1;
      }
      // Otherwise, remain on the current selection or adjust if out of bounds.
      const maxIndex = groups[groupsButton]?.sections?.length - 2;
      return Math.min(prevButton, maxIndex);
    });
  };

  const [isEditandPublished, setIsEditandPublished] = useState(false);
  const ChangeGroupName = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].group_name = e.target.value;
    setBody(updatedBody);
  };

  const ChangeRandomize_Sections = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].randomize_sections = e;
    setBody(updatedBody);
  };

  const ChangeNegativePenalityMarking = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].has_unattempted_penalty = e;
    setBody(updatedBody);
  };

  const ChangeSectionName = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].section_name = e.target.value;
    setBody(updatedBody);
  };

  const ChangeSectionIdentifier = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].identifier = Number(e.target.value);
    setBody(updatedBody);
  };

  const ChangeSectionQuestionTotal = (e) => {
    const updatedBody = { ...body };
    const value = e.target.value === '' ? e.target.value : Number(e.target.value);
    updatedBody.groups[groupsButton].sections[sectionButton].no_of_questions = value;
    setBody(updatedBody);
  };

  const ChangeSectionRandomQuestion = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].randomize_questions_within_section = Boolean(e);
    setBody(updatedBody);
  };

  const [disableMarking, setDisableMarking] = useState(true);

  const ChangeSectionCorrectMarks = (e) => {
    const updatedBody = { ...body };
    const value = e === '' ? e : Number(e);
    updatedBody.groups[groupsButton].sections[sectionButton].correct_answer_marks = value;
    setBody(updatedBody);
    ChangeMarkingLogic({
      correct_answer_marks: value,
      incorrect_answer_marks: body.groups[groupsButton].sections[sectionButton].incorrect_answer_marks,
    });
  };

  const ChangeSectionInCorrectMarks = (e) => {
    const updatedBody = { ...body };
    const value = e === '' ? e : Number(e);
    updatedBody.groups[groupsButton].sections[sectionButton].incorrect_answer_marks = value;
    setBody(updatedBody);
    ChangeMarkingLogic({
      correct_answer_marks: body.groups[groupsButton].sections[sectionButton].correct_answer_marks,
      incorrect_answer_marks: value,
    });
  };

  useEffect(() => {
    if (getBasicSettingData !== null) {
      ChangeSectionCorrectMarks(getBasicSettingData?.correct_answer_marks);
      ChangeSectionInCorrectMarks(getBasicSettingData?.incorrect_answer_marks);
    }
  }, [getBasicSettingData]);

  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (!modal) {
      setIsEditandPublished(false);
    }
  }, [modal]);
  const [removeId, setRemoveId] = useState({ rule: [], subrule: [] });

  const DeleteIdFromList = () => {
    const filteredSelectIds = body.groups[groupsButton].sections[sectionButton]?.questions.filter(
      (id) => !removeId.includes(id.id)
    );

    const updatedGroups = { ...body };
    updatedGroups.groups[groupsButton].sections[sectionButton].questions = filteredSelectIds;

    setBody(updatedGroups);
    setRemoveId([]);
  };

  const handleRemoveIds = (item, type, checked) => {
    setRemoveId((prev) => {
      // Copy the previous selections
      const updated = { ...prev };

      // Ensure the key exists
      if (!Array.isArray(updated[type])) {
        updated[type] = [];
      }

      if (checked) {
        // Add the id if not already present
        if (!updated[type].includes(item)) {
          updated[type] = [...updated[type], item];
        }
      } else {
        // Remove the id
        updated[type] = updated[type].filter((id) => id !== item);
      }
      return updated;
    });
  };
  useEffect(() => {
    // Get the current section from body.
    const currentSection = body.groups[groupsButton].sections[sectionButton];
    if (!currentSection || !currentSection.rules) return;

    const selectedRules = [];
    currentSection.rules.forEach((rule, index) => {
      // For a single rule (format 0): if its id is selected, push one item.
      if (rule.format === 0 && (removeId.rule || []).includes(rule.rule_id)) {
        selectedRules.push({
          ruleId: rule.rule_id,
          label: `Rule ${index + 1}`,
          count: 1,
          ruleFormat: 0,
        });
      }
      // For grouped rules (format 1): count the selected subrules.
      else if (rule.format === 1 && Array.isArray(rule.sub_rules)) {
        const selectedSubCount = rule.sub_rules.filter((subRule) =>
          (removeId.subrule || []).includes(subRule.sub_rule_id)
        ).length;
        if (selectedSubCount > 0) {
          selectedRules.push({
            ruleId: rule.rule_id,
            label: `Rule ${index + 1}`,
            count: selectedSubCount,
            ruleFormat: 1,
          });
        }
      }
    });
    const updatedGroups = { ...body };
    body.groups[groupsButton].sections[sectionButton].footer_selected_rules = selectedRules;
    setBody(updatedGroups);
  }, [removeId]);

  // ________ PAGINATION ________
  const [questionApiRender, setQuestionApiRender] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [last, setLast] = useState(5);

  const toast = useToast();
  useEffect(() => {
    // alert(totalCount)
    if (totalCount < 5) {
      setLast(totalCount);
    } else {
      setLast(5);
    }
  }, [totalCount]);

  const organizationId = localStorage.getItem('selectedOrgId');

  const sectionRuleListing = async () => {
    dispatch(
      Get_Rule_List(
        organizationId,
        testCreationId ?? testDetails?.id,
        body.groups[groupsButton].group_id,
        body.groups[groupsButton].sections[sectionButton].section_id
      )
    );
  };

  // useEffect(() => {
  //   if(body.groups[groupsButton].group_id && body.groups[groupsButton].sections[sectionButton].section_id){
  //     sectionRuleListing();
  //   }
  // }, [organizationId, groupsButton, sectionButton]);

  // /*****Function to open edit / delete modal */
  const [showModal, setShowModal] = useState(false);
  const [replaceId, setReplaceId] = useState(null);

  const validateSectionRule = () => {
    dispatch(
      Validate_Section_Rule_Test(
        sectionValidationBody,
        testDetails?.id ?? testCreationId,
        organizationId,
        toast,
        setModal
      )
    );
    setRuleId(null);
    setFormat(null);
    setIsEditandPublished(false);
  };
  useEffect(() => {
    if (replacedQuestion !== null) {
      const id = replacedQuestion.id;

      const newArray = body.groups[groupsButton].sections[sectionButton]?.questions.map((num) =>
        num.id === replaceId
          ? {
              id: replacedQuestion.id,
              correct_answer_marks: getBasicSettingData?.correct_answer_marks,
              incorrect_answer_marks: getBasicSettingData?.incorrect_answer_marks,
            }
          : num
      );

      const updatedGroups = { ...body };
      updatedGroups.groups[groupsButton].sections[sectionButton].questions = newArray;
      setBody(updatedGroups);
      setShowModal(false);
      sectionRuleListing();
    }
  }, [replacedQuestion]);
  useEffect(() => {
    const updatedGroups = { ...body };
    if (validateBody) {
      updatedGroups.groups[groupsButton].group_id = validateBody.data.group_id;
      updatedGroups.groups[groupsButton].sections[sectionButton].section_id = validateBody.data.section_id;
      setBody(updatedGroups);
    }
  }, [validateBody]);
  useEffect(() => {
    const updatedGroups = { ...body };
    if (ruleListBody) {
      let totalQuestions = 0;
      const updatedRules = ruleListBody.map((rule, index) => {
        totalQuestions += rule.questions_added; // Accumulate the total questions added

        return {
          ...rule,
          order: index + 1, // Assign rule_id starting from 1
        };
      });
      updatedGroups.groups[groupsButton].sections[sectionButton].rules = updatedRules;
      updatedGroups.groups[groupsButton].sections[sectionButton].section_total_question_added = totalQuestions;
      setBody(updatedGroups);
    }
  }, [ruleListBody]);
  const [markingLogicStatus, setMarkingLogicStatus] = useState(false);

  const [markingLogic, setMarkingLogic] = useState([
    {
      correct_answer_marks: getBasicSettingData?.correct_answer_marks,
      incorrect_answer_marks: getBasicSettingData?.incorrect_answer_marks,
    },
  ]);

  const AddNewScore = () => {
    setMarkingLogic((prevState) => [
      ...prevState,
      {
        correct_answer_marks: getBasicSettingData?.correct_answer_marks,
        incorrect_answer_marks: getBasicSettingData?.incorrect_answer_marks,
      },
    ]);
  };
  const [ruleId, setRuleId] = useState(null);
  const [format, setFormat] = useState(null);
  // Function to handle change event
  const handleCorrectAnswerChange = (event, i) => {
    const newValue = parseFloat(event.target.value); // Assuming input value is a number
    const updatedMarkingLogic = [...markingLogic]; // Create a copy of the state array
    updatedMarkingLogic[i] = {
      ...updatedMarkingLogic[i],
      correct_answer_marks: newValue,
    }; // Update correct_answer_marks at index 1
    setMarkingLogic(updatedMarkingLogic); // Update state with the modified array
  };

  const handleInCorrectAnswerChange = (event, i) => {
    const newValue = parseFloat(event.target.value); // Assuming input value is a number
    const updatedMarkingLogic = [...markingLogic]; // Create a copy of the state array
    updatedMarkingLogic[i] = {
      ...updatedMarkingLogic[i],
      incorrect_answer_marks: newValue,
    }; // Update correct_answer_marks at index 1
    setMarkingLogic(updatedMarkingLogic); // Update state with the modified array
  };
  const handleTimerChange = (event, sectionIndex, instructionIndex, type) => {
    let value;
    if (type === 'has_timer') {
      value = event.target.checked;
    } else {
      value = parseInt(event.target.value, 10);
    }

    setBody((prevBody) => {
      // Clone the previous state
      const newBody = { ...prevBody };
      // Access the targeted instruction
      newBody.groups[groupsButton].instructions[instructionIndex][type] = value;
      return newBody;
    });
  };

  const handleInstructionTextChange = (content, sectionIndex, instructionIndex) => {
    const answer = btoa(unescape(encodeURIComponent(content)));
    setBody((prevBody) => {
      const newBody = { ...prevBody };
      newBody.groups[groupsButton].instructions[instructionIndex].instruction_text = answer;
      return newBody;
    });
  };
  const addScreen = (sectionIndex) => {
    setBody((prevBody) => {
      const newBody = { ...prevBody };
      newBody.groups[groupsButton].instructions.push({
        has_timer: false,
        minutes: null,
        seconds: null,
        instruction_text: '',
      });
      return newBody;
    });
  };

  const removeScreen = (sectionIndex, instructionIndex) => {
    setBody((prevBody) => {
      const newBody = { ...prevBody };
      newBody.groups[groupsButton].instructions = newBody.groups[groupsButton].instructions.filter(
        (_, i) => i !== instructionIndex
      );
      return newBody;
    });
  };
  const SelectedMarkingLogic = (logic) => {
    // Create a copy of the current body state
    const updatedData = { ...body };

    // Access the current section from the group
    const currentSection = updatedData.groups[groupsButton].sections[sectionButton];

    if (currentSection && currentSection.rules) {
      currentSection.rules.forEach((rule) => {
        // For single question rules (format 0):
        if (rule.format === 0) {
          if (removeId?.rule?.includes(rule.rule_id)) {
            rule.correct_answer_marks = logic.correct_answer_marks;
            rule.incorrect_answer_marks = logic.incorrect_answer_marks;
          }
        }

        // For grouped question rules (format 1):
        if (rule.format === 1 && Array.isArray(rule.sub_rules)) {
          rule.sub_rules.forEach((subRule) => {
            if (removeId?.subrule?.includes(subRule.sub_rule_id)) {
              subRule.correct_answer_marks = logic.correct_answer_marks;
              subRule.incorrect_answer_marks = logic.incorrect_answer_marks;
            }
          });
        }
      });
    }

    // Update the state with the new values
    setBody(updatedData);
    // Optionally, clear the selections after applying the logic
    setRemoveId({ rule: [], subrule: [] });
    // Toggle the marking logic status (if you use it to show/hide the UI)
    setMarkingLogicStatus((prev) => !prev);
  };

  const ChangeMarkingLogic = (items) => {
    const updatedData = { ...body };
    updatedData.groups[groupsButton]?.sections[sectionButton]?.rules.forEach((rule) => {
      if (rule.format === 0) {
        rule.correct_answer_marks = items.correct_answer_marks;
        rule.incorrect_answer_marks = items.incorrect_answer_marks;
      }
      if (rule.format === 1 && Array.isArray(rule.sub_rules)) {
        rule.sub_rules.forEach((subRule) => {
          subRule.correct_answer_marks = items.correct_answer_marks;
          subRule.incorrect_answer_marks = items.incorrect_answer_marks;
        });
      }
    });
    setBody(updatedData);
    setRemoveId([]);
    // setMarkingLogicStatus(!markingLogicStatus);
  };

  const OpenMarkingLogic = () => {
    if (
      (Array.isArray(removeId.rule) && removeId.rule.length > 0) ||
      (Array.isArray(removeId.subrule) && removeId.subrule.length > 0)
    ) {
      setMarkingLogicStatus(!markingLogicStatus);
    } else {
      toast?.add('Please choose a rule first', 'error');
    }
  };

  const decodeBase64 = (base64String) => {
    return atob(base64String);
  };

  function b64DecodeUnicode(str) {
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }
  useEffect(() => {
    if (testDetails && testDetails?.group_details[0] && testType === 2) {
      const updatedGroups = structuredClone(testDetails)?.group_details.map((group, groupIndex) => ({
        ...group,
        order: groupIndex + 1,
        instructions:
          group?.instructions?.length > 0
            ? group.instructions
            : [
                {
                  has_timer: false,
                  minutes: null,
                  seconds: null,
                  instruction_text: '',
                },
              ],
        sections: group?.sections?.map((section, sectionIndex) => {
          const sectionTotalQuestions = section?.rules?.reduce((total, rule) => total + (rule.questions_added || 0), 0);

          return {
            ...section,
            order: sectionIndex + 1,
            section_total_question_added: sectionTotalQuestions,
            rules: section?.rules?.map((rule, ruleIndex) => ({
              ...rule,
              order: ruleIndex + 1,
            })),
          };
        }),
      }));

      setBody({ groups: updatedGroups });

      const initialGroups = updatedGroups.map((group, index) => ({
        id: index,
        sections: group?.sections?.map((section) => section?.order),
      }));

      setGroups(initialGroups);

      setMarkingLogic((prevstate) => [
        {
          correct_answer_marks: updatedGroups[groupsButton]?.sections[sectionButton]?.correct_answer_marks,
          incorrect_answer_marks: updatedGroups[groupsButton]?.sections[sectionButton]?.incorrect_answer_marks,
        },
      ]);

      setQuestionApiRender(!questionApiRender);
    }
  }, [testDetails]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    // Handle section dragging
    if (source.droppableId === 'sections-droppable') {
      // Check if dragging within the same droppable area
      if (source.droppableId === destination.droppableId) {
        setBody((prevBody) => {
          const newGroups = prevBody.groups.map((group, idx) => {
            // Only update the current group based on groupsButton
            if (idx === groupsButton) {
              const reorderedSections = reorder(group.sections, source.index, destination.index);
              // Recalculate the order
              reorderedSections.forEach((section, idx) => {
                section.order = idx + 1;
              });

              return {
                ...group,
                sections: reorderedSections,
              };
            }
            return group;
          });
          return {
            ...prevBody,
            groups: newGroups,
          };
        });

        // If you maintain separate groups state, update that as well:
        setGroups((prevGroups) => {
          const updatedGroups = prevGroups.map((group, idx) => {
            if (idx === groupsButton) {
              const reorderedSections = reorder(group.sections, source.index, destination.index);
              return {
                ...group,
                sections: reorderedSections,
              };
            }
            return group;
          });
          return updatedGroups;
        });

        // Adjust sectionButton state if needed to track currently selected section
        if (source.index === sectionButton) {
          setSectionButton(destination.index);
        } else if (source.index < sectionButton && destination.index >= sectionButton) {
          setSectionButton(sectionButton - 1);
        } else if (source.index > sectionButton && destination.index <= sectionButton) {
          setSectionButton(sectionButton + 1);
        }
      }
    }
    if (source.droppableId === 'groups-droppable') {
      setBody((prevBody) => {
        const reorderedGroups = reorder(prevBody.groups, source.index, destination.index);
        reorderedGroups.forEach((group, idx) => {
          group.order = idx + 1;
        });

        return { ...prevBody, groups: reorderedGroups };
      });

      setGroups((prevGroups) => {
        return reorder(prevGroups, source.index, destination.index).map((group, idx) => ({
          ...group,
          id: idx,
          order: idx + 1,
        }));
      });

      if (source.index === groupsButton) {
        setGroupsButton(destination.index);
      } else if (source.index < groupsButton && destination.index >= groupsButton) {
        setGroupsButton(groupsButton - 1);
      } else if (source.index > groupsButton && destination.index <= groupsButton) {
        setGroupsButton(groupsButton + 1);
      }
    }
    if (source.droppableId === 'rules-droppable') {
      setBody((prevBody) => {
        const updatedGroups = prevBody.groups.map((group, gIdx) => {
          if (gIdx !== groupsButton) return group; // Keep other groups unchanged

          return {
            ...group,
            sections: group.sections.map((section, sIdx) => {
              if (sIdx !== sectionButton) return section; // Keep other sections unchanged

              // Reorder the rules
              const reorderedRules = reorder(section.rules, source.index, destination.index).map((rule, index) => ({
                ...rule,
                order: index + 1, // Ensure a new object is created
              }));

              return {
                ...section,
                rules: reorderedRules,
              };
            }),
          };
        });

        return { ...prevBody, groups: updatedGroups };
      });
    }
  };
  // Helper: reorder function
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const deleteRuleSubRule = async (group_id, section_id, rules, subRules, id, format, deleteFormat) => {
    const url = `${DELETE_SECTION_RULE_SUBRULE_LIST}${organizationId}/?test_id=${testCreationId ?? testDetails.id}&group_id=${group_id}&section_id=${section_id}&rule_ids=${rules}&sub_rule_ids=${subRules}`;
    try {
      const response = await CallWithAuth('DELETE', url, {});
      if (response.status && response.res.status === 200) {
        toast?.remove('all');
        toast?.add(response?.res?.data?.message, 'success');
        if (deleteFormat === 'single') {
          setBody((prevBody) => {
            const updatedBody = { ...prevBody };
            const footerRules = updatedBody?.groups[groupsButton]?.sections[sectionButton]?.footer_selected_rules;

            // Update the rule count or remove it if count reaches 0
            const updatedFooterRules = footerRules
              ?.map((rule) => {
                if (rule?.ruleId === id && rule?.ruleFormat === format) {
                  if (rule?.count > 1) {
                    return { ...rule, count: rule?.count - 1 }; // Decrease count
                  }
                  return null; // Remove rule if count is 0
                }
                return rule;
              })
              .filter(Boolean); // Remove null values (rules with count 0)

            updatedBody.groups[groupsButton].sections[sectionButton].footer_selected_rules = updatedFooterRules;
            setRemoveId((prevRemoveId) => {
              const updatedRemoveId = { ...prevRemoveId };

              if (format === 0) {
                updatedRemoveId.rule = updatedRemoveId?.rule?.filter((ruleId) => ruleId !== id);
              } else if (format === 1) {
                updatedRemoveId.subrule = updatedRemoveId?.subrule?.filter((subruleId) => subruleId !== subRules);
              }

              return updatedRemoveId;
            });
            return updatedBody;
          });
        } else {
          setBody((prevBody) => {
            const updatedBody = { ...prevBody };
            updatedBody.groups[groupsButton].sections[sectionButton].footer_selected_rules = [];
            return updatedBody;
          });

          // Also reset removeId state
          setRemoveId({ rule: [], subrule: [] });
        }
        sectionRuleListing();
      } else {
        toast?.remove('all');
        toast?.add(response?.res?.data?.error, 'error');
      }
    } catch (error) {
      console.log(error);
      toast?.remove('all');
      toast?.add(error, 'error');
    }
  };
  const deleteRule = (id, format, mainId) => {
    setCurrentDeleteRuleID({ format: format, id: id });
    if (format === 0) {
      deleteRuleSubRule(
        body?.groups[groupsButton]?.group_id,
        body?.groups[groupsButton]?.sections[sectionButton]?.section_id,
        id,
        '',
        mainId,
        format,
        'single'
      );
    } else {
      deleteRuleSubRule(
        body?.groups[groupsButton]?.group_id,
        body?.groups[groupsButton]?.sections[sectionButton]?.section_id,
        '',
        id,
        mainId,
        format,
        'single'
      );
    }
  };
  const deleteMultiRule = async () => {
    // Extract rule IDs based on ruleFormat
    const sectionRule = body?.groups[groupsButton]?.sections[sectionButton]?.footer_selected_rules;
    if (sectionRule.length > 0) {
      const rule_ids = removeId?.rule?.join(',') || '';
      const subrule_ids = removeId?.subrule?.join(',') || '';
      deleteRuleSubRule(
        body?.groups[groupsButton]?.group_id,
        body.groups[groupsButton]?.sections[sectionButton]?.section_id,
        rule_ids,
        subrule_ids,
        '',
        format,
        'mulitidelete'
      );
    } else {
      toast?.add('Please choose a rule first', 'error');
    }
  };

  return (
    <div className={`${style.masterTestCreation} ${style.loftTestCreation}`}>
      <DragDropContext onDragEnd={handleDragEnd}>
        <div className={`${style.testCreationArea}`}>
          <div className={style.containGroup}>
            <Droppable droppableId="groups-droppable" direction="horizontal">
              {(provided) => (
                <div className={style.bisectAdd} ref={provided.innerRef} {...provided.droppableProps}>
                  {groups?.map((items, i) =>
                    !isView ? (
                      <Draggable key={i} draggableId={`group-${i}`} index={i}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <div
                              key={i}
                              draggable="true"
                              className={
                                i === groupsButton
                                  ? ` ${style.multiquestionbutton} ${style.draggable}`
                                  : ` ${style.multiquestionbuttonBlue} ${style.draggable}`
                              }
                              onClick={() => {
                                setGroupsButton(i);
                                setSectionButton(0);
                              }}
                            >
                              {i === groupsButton ? (
                                <svg
                                  width="10"
                                  height="14"
                                  viewBox="0 0 10 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                    fill="white"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="10"
                                  height="14"
                                  viewBox="0 0 10 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                    fill="#272727"
                                  />
                                </svg>
                              )}{' '}
                              &nbsp; Group {i + 1}
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ) : (
                      <button
                        key={i}
                        draggable="true"
                        className={
                          i === groupsButton
                            ? ` ${style.multiquestionbutton} ${style.draggable}`
                            : ` ${style.multiquestionbuttonBlue} ${style.draggable}`
                        }
                        onClick={() => {
                          setGroupsButton(i);
                          setSectionButton(0);
                        }}
                      >
                        {i === groupsButton ? (
                          <svg
                            width="10"
                            height="14"
                            viewBox="0 0 10 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                              fill="white"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="10"
                            height="14"
                            viewBox="0 0 10 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                              fill="#272727"
                            />
                          </svg>
                        )}{' '}
                        &nbsp; Group {i + 1}
                      </button>
                    )
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            <div className={`${style.icon_text} ${style.group_icon} ${isView ? style.isViewMainContainer : ''}`}>
              <div className={`${style.icon_text} ${style.group_icon} ${isView ? style.isViewMainContainer : ''}`}>
                <p className={style.info}>Randomize Sections</p>
                <div
                  style={{
                    border: '1px solid #3ebb5d',
                    height: '20px',
                    width: '20px',
                    borderRadius: '6px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => ChangeRandomize_Sections(!body.groups[groupsButton].randomize_sections)}
                >
                  <div className={`${style.check_btn}`}>
                    {body.groups[groupsButton].randomize_sections ? (
                      <svg width="25" height="24" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                          fill="url(#paint0_linear_1449_53208)"
                        />
                        <path
                          d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_1449_53208"
                            x1="22"
                            y1="2"
                            x2="7.89816"
                            y2="18.4928"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#9BF763" />
                            <stop offset="1" stopColor="#25AB5B" />
                          </linearGradient>
                        </defs>
                      </svg>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!isView && (
            <div style={{ display: 'flex', justifyContent: 'space-between' }} className={style.threshold}>
              <div
                className={style.setter}
                // onClick={() => setGroups((current) => [...current, groups.length])}
                onClick={() => addGroup()}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#00ABFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.5 12H16.5"
                    stroke="#00ABFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 16.5V7.5"
                    stroke="#00ABFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <h5>Add Group</h5>
              </div>
              {/* group add button  */}
              {groups.length > 1 && (onAdd || (isEdit && testDetails?.remove_groups)) && (
                <button className={style.removeGroupButton} onClick={() => closegroups()}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                      stroke="#272727"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                      stroke="#272727"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                      stroke="#272727"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span style={{ marginLeft: '6px', fontSize: '12px' }}>Remove Group</span>
                </button>
              )}
            </div>
          )}

          {body.groups
            .filter((item, key) => key === groupsButton)
            .map((items, i) => (
              <div key={i} className={style.section_form}>
                <h5 className={style.testMarklabel} style={{ marginTop: '0px', marginBottom: '20px' }}>
                  Group Details
                </h5>
                {/* group details -body  */}
                <div className={`${style.groupName} ${isView ? style.isViewMainContainer : ''}`}>
                  <span style={{ fontSize: '14px', fontWeight: '500' }}>
                    Group Name
                    <b className={style.red_mendantory}>*</b>
                  </span>

                  <input
                    type="text"
                    placeholder="Group Name"
                    className={style.groupDrop}
                    onChange={(e) => ChangeGroupName(e)}
                    value={items.group_name}
                  />

                  <div className={style.sectionInstruction}>
                    <div className={style.sectionHeading}>Group Instructions</div>
                    <p className={style.info}>Add instructions to appear before the section commences</p>
                    {items.instructions.map((instruction, instructionIndex) => (
                      <div key={instructionIndex} className={style.screenNum}>
                        <p style={{ fontWeight: 500, margin: '5px 0px' }}>Screen {instructionIndex + 1}</p>
                        <div className={style.icon_text}>
                          <label className="custom-checkbox" aria-label="Has Timer">
                            <input
                              type="checkbox"
                              checked={Boolean(instruction.has_timer)}
                              onChange={(e) => handleTimerChange(e, i, instructionIndex, 'has_timer')}
                            />
                            <span className="checkmark"></span>
                          </label>
                          <p className={style.info}>Instruction Screen has a timer</p>
                        </div>

                        <div>
                          {instruction.has_timer && (
                            <div className={style.sectionTimer}>
                              <p className={style.marketLogic}>Instruction Timer</p>
                              <div className={`${style.timer} ${style.instrTimer}`}>
                                <input
                                  onKeyDown={(event) => {
                                    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                      event.preventDefault();
                                    }
                                  }}
                                  onWheel={(e) => e.target.blur()}
                                  autoComplete="off"
                                  className={style.timer_input}
                                  type="number"
                                  name="minutes"
                                  min="0"
                                  max="100"
                                  step="1"
                                  value={instruction.minutes ?? ''}
                                  onChange={(e) => handleTimerChange(e, i, instructionIndex, 'minutes')}
                                />
                                <label htmlFor="minutes" style={{ marginRight: '18px' }}>
                                  Minutes
                                </label>
                                <input
                                  onKeyDown={(event) => {
                                    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                      event.preventDefault();
                                    }
                                  }}
                                  onWheel={(e) => e.target.blur()}
                                  autoComplete="off"
                                  className={style.timer_input}
                                  type="number"
                                  name="seconds"
                                  min="0"
                                  max="100"
                                  step="1"
                                  value={instruction.seconds ?? ''}
                                  onChange={(e) => handleTimerChange(e, i, instructionIndex, 'seconds')}
                                />
                                <label htmlFor="seconds">Seconds</label>
                              </div>
                            </div>
                          )}
                          <p className={style.marketLogic} style={{ margin: '10px 0px' }}>
                            Group Instructions
                          </p>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', width: '84%' }}>
                            <div style={{ height: 'auto', flexGrow: '1' }}>
                              <QuillEditor
                                defaultValue={decodeBase64(instruction.instruction_text)}
                                disabled={isView}
                                onChange={(content) => handleInstructionTextChange(content, i, instructionIndex)}
                              />
                            </div>
                            {instructionIndex !== 0 && (
                              <button
                                type="button"
                                className={style.penaltyDelete}
                                onClick={() => removeScreen(i, instructionIndex)}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                    stroke="#272727"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                    stroke="#272727"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                    stroke="#272727"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                    {/* {!isView && (
                      <button
                        onClick={() => addScreen(i)}
                        className={`${style.addSetButton} ${style.threshold} ${style.addInstrButton}`}
                        style={{ margin: '20px 0 8px' }}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                            stroke="#00ABFB"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.5 12H16.5"
                            stroke="#00ABFB"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 16.5V7.5"
                            stroke="#00ABFB"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <h5 className={style.add_btn} style={{ margin: '0px' }}>
                          Add Instruction Screen
                        </h5>
                      </button>
                    )} */}
                  </div>
                </div>
                <div
                  className={`${style.icon_text}  ${isView ? style.isViewMainContainer : ''}`}
                  style={{ marginBottom: '10px' }}
                >
                  <label className="custom-checkbox" aria-label="Has Timer">
                    <input
                      type="checkbox"
                      checked={Boolean(items.has_unattempted_penalty)}
                      onChange={() => ChangeNegativePenalityMarking(!items.has_unattempted_penalty)}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <p className={style.info}>Unattempted penalty applies for this group</p>
                </div>
                <h5 className={style.testMarklabel} style={{ marginTop: '0px' }}>
                  Section Details
                </h5>
                {/* section buttons  */}
                <Droppable droppableId="sections-droppable" direction="horizontal">
                  {(provided) => (
                    <div
                      className={`${style.sectionTestCreation}`}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      <div className={style.containGroup}>
                        {items.sections?.map((items, i) =>
                          !isView ? (
                            <Draggable key={i} draggableId={`section-${i}`} index={i}>
                              {(provided, snapshot) => (
                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                  <div
                                    key={i}
                                    className={
                                      i === sectionButton
                                        ? ` ${style.multiquestionbutton} ${style.draggable}`
                                        : ` ${style.multiquestionbuttonBlue} ${style.draggable}`
                                    }
                                    onClick={() => {
                                      setSectionButton(i);
                                    }}
                                  >
                                    {i === sectionButton ? (
                                      <svg
                                        width="10"
                                        height="14"
                                        viewBox="0 0 10 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                          fill="white"
                                        />
                                      </svg>
                                    ) : (
                                      <svg
                                        width="10"
                                        height="14"
                                        viewBox="0 0 10 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                          fill="#272727"
                                        />
                                      </svg>
                                    )}{' '}
                                    &nbsp; Section {i + 1}
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          ) : (
                            <div
                              key={i}
                              className={
                                i === sectionButton
                                  ? ` ${style.multiquestionbutton}`
                                  : ` ${style.multiquestionbuttonBlue}`
                              }
                              onClick={() => {
                                setSectionButton(i);
                              }}
                            >
                              &nbsp; Section {i + 1}
                            </div>
                          )
                        )}
                        {provided.placeholder}
                      </div>
                    </div>
                  )}
                </Droppable>
                {/* section add button  */}
                {!isView && (
                  <div style={{ display: 'flex', justifyContent: 'space-between' }} className={style.threshold}>
                    <div
                      className={style.setter}
                      style={{ margin: '22px 0' }}
                      onClick={() => addSection(groups[groupsButton].id)}
                    >
                      {' '}
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                          stroke="#00ABFB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7.5 12H16.5"
                          stroke="#00ABFB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 16.5V7.5"
                          stroke="#00ABFB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <h5 style={{ margin: '0' }}>Add Section</h5>{' '}
                    </div>

                    {items.sections.length > 1 && (onAdd || (isEdit && testDetails?.remove_sections)) && (
                      <button
                        className={`${style.removeGroupButton} ${style.section_remove}`}
                        onClick={() => deleteSection(groups[groupsButton].id, sectionButton)}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span style={{ marginLeft: '6px', fontSize: '12px' }}>Remove Section</span>
                      </button>
                    )}
                  </div>
                )}

                {items.sections
                  .filter((item, key) => key === sectionButton)
                  .map((sectionItem, sectionKey) => (
                    <div
                      className={`${style.pageTwoSection} ${style.pageSection} ${isView ? style.isViewMainContainer : ''}`}
                      key={sectionKey}
                    >
                      <div className={style.bound}>
                        <div className={style.templateDrop} style={{ marginBottom: '0px' }} key={sectionKey}>
                          <div className={style.templateDrop_item}>
                            <div className={style.templateGroup}>
                              <span>Section Name </span>
                              <b className={style.red_mendantory}>*</b>
                              <input
                                name="question"
                                id="question"
                                className={` ${style.score_drop_filter} ${style.verbalBox}`}
                                placeholder=""
                                onChange={(e) => ChangeSectionName(e)}
                                value={sectionItem.section_name}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Test type */}
                        <div className={style.templateDrop} key={sectionKey}>
                          <div className={style.templateDrop_item}>
                            <div className={style.templateGroup}>
                              <span>Section Identifier </span>
                              <b className={style.red_mendantory}>*</b>
                              <select
                                name="question"
                                id="question"
                                value={
                                  sectionItem.identifier === null ? 'Select Section Identifier' : sectionItem.identifier
                                }
                                onChange={(e) => ChangeSectionIdentifier(e)}
                                className={` ${style.template_drop_filter} ${style.varc}`}
                                style={{ width: '250px' }}
                              >
                                <option value={null}>Select Section Identifier</option>
                                {Array.isArray(identifierList) &&
                                  identifierList?.map((items, i) => (
                                    <option key={i} value={items?.id}>
                                      {items?.name}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className={style.templateDrop} key={sectionKey}>
                          <div className={style.templateDrop_item}>
                            <div className={style.templateGroup}>
                              <span>No. of Questions </span>
                              <b className={style.red_mendantory}>*</b>
                              <input
                                name="question"
                                id="question"
                                type="number"
                                autoComplete="off"
                                className={style.score_drop_filter}
                                placeholder=""
                                onChange={(e) => ChangeSectionQuestionTotal(e)}
                                value={sectionItem.no_of_questions}
                                onKeyDown={(event) => {
                                  if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                    event.preventDefault();
                                  }
                                }}
                                onWheel={(e) => e.target.blur()}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <p style={{ fontWeight: '500' }} className={style.marketLogic}>
                        Randomize Questions
                      </p>
                      {/* <div className={style.levels}>
                      <input
                        type="radio"
                        checked={sectionItem.randomize_questions_within_section}
                        onClick={() => ChangeSectionRandomQuestion(true)}
                      />
                      <label htmlFor="test level">Yes</label>
                      <input
                        style={{ marginLeft: '20px' }}
                        checked={!sectionItem.randomize_questions_within_section}
                        onClick={() => ChangeSectionRandomQuestion(false)}
                        type="radio"
                      />
                      <label htmlFor="section level">No</label>
                    </div> */}
                      <div className={`${style.randmizeQue} ${style.custom_input_container}`}>
                        <input
                          type="radio"
                          id="randomizeQuestionsYes"
                          className={style.custom_radio}
                          checked={sectionItem.randomize_questions_within_section}
                          onClick={() => ChangeSectionRandomQuestion(true)}
                        />{' '}
                        <label htmlFor="randomizeQuestionsYes">Yes</label>
                        <input
                          type="radio"
                          id="randomizeQuestionsNo"
                          className={style.custom_radio}
                          checked={!sectionItem.randomize_questions_within_section}
                          onClick={() => ChangeSectionRandomQuestion(false)}
                        />{' '}
                        <label htmlFor="randomizeQuestionsNo">No</label>
                      </div>
                      <h3 className={style.testMarklabel} style={{ marginTop: '24px', marginBottom: '10px' }}>
                        Section Marking Details
                      </h3>
                      <p className={style.info}>
                        Editing marking logic will only apply to selected section. All questions will follow same
                        marking logic unless new marking logics are created
                      </p>
                      <div className={style.bound}>
                        <div className={style.templateDrop} key={sectionKey}>
                          <div className={style.templateDrop_item}>
                            <div className={style.templateGroup}>
                              <span>Correct Answer Marks </span>
                              <b className={style.red_mendantory}>*</b>
                              <input
                                onKeyDown={(event) => {
                                  if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                    event.preventDefault();
                                  }
                                }}
                                onWheel={(e) => e.target.blur()}
                                autoComplete="off"
                                type="number"
                                name="question"
                                disabled={disableMarking}
                                id="question"
                                style={{ marginBottom: '5px' }}
                                className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                                placeholder=""
                                onChange={(e) => ChangeSectionCorrectMarks(e.target.value)}
                                value={
                                  sectionItem.correct_answer_marks === null ? '' : sectionItem.correct_answer_marks
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <div className={style.templateDrop}>
                          <div className={style.templateDrop_item}>
                            <div className={style.templateGroup}>
                              <span>Incorrect Answer Marks </span>
                              <b className={style.red_mendantory}>*</b>
                              <input
                                onKeyDown={(event) => {
                                  if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                    event.preventDefault();
                                  }
                                }}
                                onWheel={(e) => e.target.blur()}
                                autoComplete="off"
                                type="number"
                                disabled={disableMarking}
                                name="question"
                                id="question"
                                style={{ marginBottom: '5px' }}
                                className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                                placeholder=""
                                onChange={(e) => ChangeSectionInCorrectMarks(e.target.value)}
                                value={
                                  sectionItem.incorrect_answer_marks === null ? '' : sectionItem.incorrect_answer_marks
                                }
                              />
                            </div>
                          </div>
                        </div>
                        {!isView && (
                          <div>
                            {disableMarking ? (
                              <div
                                onClick={() => setDisableMarking(false)}
                                style={{ cursor: 'pointer' }}
                                className={style.threshold}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3 22H21"
                                    stroke="#00ABFB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z"
                                    stroke="#00ABFB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M11.8906 5.04883C12.3206 7.80883 14.5606 9.91883 17.3406 10.1988"
                                    stroke="#00ABFB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>

                                <h5>Edit</h5>
                              </div>
                            ) : (
                              <div
                                onClick={() => setDisableMarking(true)}
                                style={{ cursor: 'pointer' }}
                                className={style.threshold}
                              >
                                <h5>Done</h5>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                    fill="url(#paint0_linear_1449_53208)"
                                  />
                                  <path
                                    d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_1449_53208"
                                      x1="22"
                                      y1="2"
                                      x2="7.89816"
                                      y2="18.4928"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#00ABFB" />
                                      <stop offset="1" stopColor="#00ABFB" />
                                    </linearGradient>
                                  </defs>
                                </svg>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      {sectionItem?.rules.length === 0 ? (
                        <div className={style.ruleContainer}>
                          <h2 className={style.title}>No Rules Added !</h2>
                          <p className={style.description}>
                            Please click &quot;Add questions from question bank&quot; button to proceed.
                          </p>
                          {!isView && (
                            <button className={style.addButton} onClick={validateSectionRule}>
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M2.16797 10H18.168"
                                  stroke="#00ABFB"
                                  strokeWidth="3"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M10.168 18V2"
                                  stroke="#00ABFB"
                                  strokeWidth="3"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <span style={{ marginLeft: '5px' }}>Add Rules To Section</span>
                            </button>
                          )}
                        </div>
                      ) : (
                        <div>
                          <div className={style.ruleAddedContainer}>
                            <div className={style.rulelistContainer}>
                              <div style={{ width: '75%', float: 'left' }}>
                                <h2 className={style.header}>Rule List</h2>
                                <p className={style.subHeader}>
                                  <span className={style.queText}>No. of questions: </span>
                                  <span className={style.queValue}>
                                    {sectionItem.section_total_question_added}/{sectionItem?.no_of_questions}
                                  </span>
                                </p>
                              </div>
                              <div style={{ width: '26%', float: 'right', textAlign: 'right' }}>
                                <button
                                  className={`${style.addButton} ${
                                    sectionItem.section_total_question_added >= sectionItem.no_of_questions
                                      ? style.disabledButton
                                      : ''
                                  }`}
                                  style={{ visibility: isView ? 'hidden' : 'visible' }}
                                  onClick={validateSectionRule}
                                  disabled={sectionItem.section_total_question_added >= sectionItem.no_of_questions}
                                >
                                  <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.16797 10H18.168"
                                      stroke="#00ABFB"
                                      strokeWidth="3"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M10.168 18V2"
                                      stroke="#00ABFB"
                                      strokeWidth="3"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                  <span style={{ marginLeft: '5px' }}>Add Rules To Section</span>
                                </button>
                              </div>
                            </div>
                            <Droppable droppableId={`rules-droppable`} direction="vertical" type="rules">
                              {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                  {sectionItem?.rules?.map((rule, index) => {
                                    const ruleContent = (
                                      <div className={style.dragRuleList}>
                                        <div style={{ marginTop: rule.format === 0 ? '10px' : '0px' }}>
                                          {!isView ? (
                                            <svg
                                              width="20"
                                              height="20"
                                              viewBox="0 0 20 20"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M8.4375 4.6875C8.4375 4.93473 8.36419 5.1764 8.22684 5.38196C8.08949 5.58752 7.89426 5.74774 7.66585 5.84235C7.43745 5.93696 7.18611 5.96171 6.94364 5.91348C6.70116 5.86525 6.47843 5.7462 6.30362 5.57138C6.1288 5.39657 6.00975 5.17384 5.96152 4.93136C5.91329 4.68889 5.93804 4.43755 6.03265 4.20915C6.12726 3.98074 6.28748 3.78552 6.49304 3.64816C6.6986 3.51081 6.94027 3.4375 7.1875 3.4375C7.51902 3.4375 7.83696 3.5692 8.07138 3.80362C8.3058 4.03804 8.4375 4.35598 8.4375 4.6875ZM12.8125 5.9375C13.0597 5.9375 13.3014 5.86419 13.507 5.72684C13.7125 5.58949 13.8727 5.39426 13.9674 5.16585C14.062 4.93745 14.0867 4.68611 14.0385 4.44364C13.9903 4.20116 13.8712 3.97843 13.6964 3.80362C13.5216 3.6288 13.2988 3.50975 13.0564 3.46152C12.8139 3.41329 12.5626 3.43804 12.3341 3.53265C12.1057 3.62726 11.9105 3.78748 11.7732 3.99304C11.6358 4.1986 11.5625 4.44027 11.5625 4.6875C11.5625 5.01902 11.6942 5.33696 11.9286 5.57138C12.163 5.8058 12.481 5.9375 12.8125 5.9375ZM7.1875 8.75C6.94027 8.75 6.6986 8.82331 6.49304 8.96066C6.28748 9.09802 6.12726 9.29324 6.03265 9.52165C5.93804 9.75005 5.91329 10.0014 5.96152 10.2439C6.00975 10.4863 6.1288 10.7091 6.30362 10.8839C6.47843 11.0587 6.70116 11.1778 6.94364 11.226C7.18611 11.2742 7.43745 11.2495 7.66585 11.1549C7.89426 11.0602 8.08949 10.9 8.22684 10.6945C8.36419 10.4889 8.4375 10.2472 8.4375 10C8.4375 9.66848 8.3058 9.35054 8.07138 9.11612C7.83696 8.8817 7.51902 8.75 7.1875 8.75ZM12.8125 8.75C12.5653 8.75 12.3236 8.82331 12.118 8.96066C11.9125 9.09802 11.7523 9.29324 11.6577 9.52165C11.563 9.75005 11.5383 10.0014 11.5865 10.2439C11.6348 10.4863 11.7538 10.7091 11.9286 10.8839C12.1034 11.0587 12.3262 11.1778 12.5686 11.226C12.8111 11.2742 13.0624 11.2495 13.2909 11.1549C13.5193 11.0602 13.7145 10.9 13.8518 10.6945C13.9892 10.4889 14.0625 10.2472 14.0625 10C14.0625 9.66848 13.9308 9.35054 13.6964 9.11612C13.462 8.8817 13.144 8.75 12.8125 8.75ZM7.1875 14.0625C6.94027 14.0625 6.6986 14.1358 6.49304 14.2732C6.28748 14.4105 6.12726 14.6057 6.03265 14.8341C5.93804 15.0626 5.91329 15.3139 5.96152 15.5564C6.00975 15.7988 6.1288 16.0216 6.30362 16.1964C6.47843 16.3712 6.70116 16.4903 6.94364 16.5385C7.18611 16.5867 7.43745 16.562 7.66585 16.4674C7.89426 16.3727 8.08949 16.2125 8.22684 16.007C8.36419 15.8014 8.4375 15.5597 8.4375 15.3125C8.4375 14.981 8.3058 14.663 8.07138 14.4286C7.83696 14.1942 7.51902 14.0625 7.1875 14.0625ZM12.8125 14.0625C12.5653 14.0625 12.3236 14.1358 12.118 14.2732C11.9125 14.4105 11.7523 14.6057 11.6577 14.8341C11.563 15.0626 11.5383 15.3139 11.5865 15.5564C11.6348 15.7988 11.7538 16.0216 11.9286 16.1964C12.1034 16.3712 12.3262 16.4903 12.5686 16.5385C12.8111 16.5867 13.0624 16.562 13.2909 16.4674C13.5193 16.3727 13.7145 16.2125 13.8518 16.007C13.9892 15.8014 14.0625 15.5597 14.0625 15.3125C14.0625 14.981 13.9308 14.663 13.6964 14.4286C13.462 14.1942 13.144 14.0625 12.8125 14.0625Z"
                                                fill="#272727"
                                              />
                                            </svg>
                                          ) : (
                                            ''
                                          )}
                                        </div>
                                        <div style={{ paddingLeft: '5px', width: '100%' }}>
                                          {rule.format === 0 && (
                                            <div>
                                              <div className={style.ruleTopHeader}>
                                                <div className={style.changeCheckbox} key={removeId.length}>
                                                  <div className={style.ruleTitleLeft}>
                                                    {!isView && (
                                                      <label
                                                        className="custom-checkbox"
                                                        aria-label="checkbox"
                                                        style={{ marginRight: '8px' }}
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          checked={removeId?.rule?.includes(rule.rule_id)}
                                                          onChange={(e) =>
                                                            handleRemoveIds(rule.rule_id, 'rule', e.target.checked)
                                                          }
                                                        />
                                                        <span className="checkmark"></span>
                                                      </label>
                                                    )}
                                                    <h3
                                                      style={{ pointerEvents: 'all', marginBottom: '0px' }}
                                                      className={style.ruleTitle}
                                                      onClick={() => {
                                                        setModal(true);
                                                        setRuleId(rule.rule_id);
                                                        setFormat(rule.format);

                                                        setIsEditandPublished(true);
                                                      }}
                                                    >
                                                      <span className={style.ruleTitleBorder}>Rule {index + 1}</span>
                                                    </h3>
                                                  </div>
                                                  <div className={style.ruleTitleRight}>
                                                    <div
                                                      className={`${style.changesEvent}`}
                                                      style={{ margin: '0 8px' }}
                                                    >
                                                      <input
                                                        type="text"
                                                        style={{
                                                          display: 'inline',
                                                          width: '20%',
                                                          border: 'none',
                                                          background: 'transparent',
                                                        }}
                                                        value={rule?.correct_answer_marks}
                                                        disabled
                                                      />
                                                      <input
                                                        type="text"
                                                        style={{
                                                          display: 'inline',
                                                          width: '20%',
                                                          border: 'none',
                                                          background: 'transparent',
                                                        }}
                                                        value={rule?.incorrect_answer_marks}
                                                        disabled
                                                      />
                                                    </div>
                                                    {!isView && (onAdd || (isEdit && testDetails?.remove_rules)) && (
                                                      <span>
                                                        <img
                                                          src={ruleEdit}
                                                          className={style.iconInfo}
                                                          style={{ margin: '0 8px' }}
                                                          alt="edit"
                                                          onClick={() => {
                                                            setModal(true);
                                                            setRuleId(rule.rule_id);
                                                            setFormat(rule.format);
                                                            setIsEditandPublished(false);
                                                          }}
                                                        />
                                                        <img
                                                          src={ruleDelete}
                                                          className={style.iconInfo}
                                                          style={{ margin: '0px 0px 0px 8px' }}
                                                          alt="delete"
                                                          onClick={() =>
                                                            deleteRule(rule.rule_id, rule.format, rule.rule_id)
                                                          }
                                                        />
                                                      </span>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                <p className={style.ruleInfo}>
                                                  <span className={style.queBankTitle}>Question bank:</span>{' '}
                                                  <span className={style.queBankName} style={{ marginLeft: '5px' }}>
                                                    {rule.question_bank_name}
                                                  </span>
                                                </p>
                                                <p className={style.ruleInfo}>
                                                  <div className={style.ruleTextInfo}>
                                                    <span className={style.labelTitle}>Format:</span>{' '}
                                                    <span className={style.labelText}>Single Question</span>
                                                  </div>
                                                  <div className={style.ruleTextInfo}>
                                                    <span className={style.labelTitle}>Question Type:</span>{' '}
                                                    <span className={style.labelText}>{rule.type}</span>
                                                  </div>
                                                  <div className={style.ruleTextInfo}>
                                                    <span className={style.labelTitle}>LOD:</span>{' '}
                                                    <span className={style.labelText}>{rule.lod}</span>
                                                  </div>
                                                  <div className={style.ruleTextInfo}>
                                                    <span className={style.labelTitle}>Academic Year:</span>{' '}
                                                    <span className={style.labelText}>
                                                      {rule.academic_year_after} - {rule.academic_year_before}
                                                    </span>
                                                  </div>
                                                  <span className={style.labelTitle}>Questions Added: </span>{' '}
                                                  <span className={style.labelText}></span>{' '}
                                                  <span className={style.labelText} style={{ marginLeft: '4px' }}>
                                                    {rule.rule_total_lock_questions}/{rule.rule_total_match_questions}
                                                  </span>
                                                </p>
                                                <div className={style.tags}>
                                                  {rule?.primary_tags?.map((tag, index) => (
                                                    <span key={`${index}-${tag}`} className={style.tag}>
                                                      {tag?.primary_tag?.slug}
                                                    </span>
                                                  ))}
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                          {rule.format === 1 && (
                                            <div>
                                              <div className={style.ruleTopHeader}>
                                                <div style={{ width: '90%' }}>
                                                  <h3
                                                    onClick={() => {
                                                      setModal(true);
                                                      setRuleId(rule.rule_id);
                                                      setFormat(rule.format);

                                                      setIsEditandPublished(true);
                                                    }}
                                                    style={{ pointerEvents: 'all' }}
                                                    className={style.ruleTitle}
                                                  >
                                                    <span className={style.ruleTitleBorder}>Rule {index + 1}</span>
                                                  </h3>
                                                </div>
                                                <div
                                                  className={style.collapseIcon}
                                                  onClick={() => toggleCollapse(rule.rule_id)}
                                                  style={{ pointerEvents: 'all', width: '10%', textAlign: 'right' }}
                                                >
                                                  <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className={
                                                      collapsedRules[rule.rule_id]
                                                        ? style.iconCollapsed
                                                        : style.iconExpanded
                                                    }
                                                    style={{ cursor: 'pointer' }}
                                                  >
                                                    <path
                                                      d="M5 7L10 12L15 7"
                                                      stroke="#00ABFB"
                                                      strokeWidth="2"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                              <p className={style.ruleInfo} style={{ marginBottom: '0px' }}>
                                                <span className={style.queBankTitle}>Question bank:</span>{' '}
                                                <span className={style.queBankName} style={{ marginLeft: '5px' }}>
                                                  {rule.question_bank_name}
                                                </span>
                                              </p>
                                              <div className={style.ruleMiddleContainer}>
                                                <div className={style.ruleMiddleContainerLeft} style={{ width: '85%' }}>
                                                  <p
                                                    className={style.ruleInfo}
                                                    style={{ marginTop: '0px', marginBottom: '0px' }}
                                                  >
                                                    <div className={style.ruleTextInfo}>
                                                      <span className={style.labelTitle}>Format:</span>{' '}
                                                      <span className={style.labelText}>Grouped Question</span>
                                                    </div>
                                                    <div className={style.ruleTextInfo}>
                                                      <span className={style.labelTitle}>No. of Passages:</span>{' '}
                                                      <span className={style.labelText}>{rule.no_of_passages}</span>
                                                    </div>
                                                    <div className={style.ruleTextInfo}>
                                                      <span className={style.labelTitle}>No. of Questions:</span>{' '}
                                                      <span className={style.labelText}>{rule.no_of_questions}</span>
                                                    </div>
                                                    <div className={style.ruleTextInfo}>
                                                      <span className={style.labelTitle}>Academic Year:</span>{' '}
                                                      <span className={style.labelText}>
                                                        {rule.academic_year_after} - {rule.academic_year_before}
                                                      </span>
                                                    </div>
                                                    <span className={style.labelTitle}>Questions Added:</span>{' '}
                                                    <span style={{ marginLeft: '4px' }} className={style.labelText}>
                                                      {rule.rule_total_lock_questions}/{rule.rule_total_match_questions}
                                                    </span>
                                                  </p>
                                                </div>
                                                <div
                                                  className={style.ruleMiddleContainerRight}
                                                  style={{ width: '15%' }}
                                                >
                                                  {!isView && (onAdd || (isEdit && testDetails?.remove_rules)) && (
                                                    <span>
                                                      <img
                                                        src={ruleEdit}
                                                        className={style.iconInfo}
                                                        style={{ margin: '0 8px' }}
                                                        alt="edit"
                                                        onClick={() => {
                                                          setModal(true);
                                                          setRuleId(rule.rule_id);
                                                          setFormat(rule.format);
                                                          setIsEditandPublished(false);
                                                        }}
                                                      />
                                                      <img
                                                        src={ruleDelete}
                                                        className={style.iconInfo}
                                                        style={{ margin: '0px 0px 0px 8px' }}
                                                        alt="delete"
                                                        onClick={() => deleteRule(rule.rule_id, 0, rule.rule_id)}
                                                      />
                                                    </span>
                                                  )}
                                                </div>
                                              </div>
                                              <div>
                                                <div
                                                  className={`${style.subRulesContainer} ${collapsedRules[rule.rule_id] ? style.collapsedAnimation : style.expandedAnimation}`}
                                                >
                                                  {rule?.sub_rules?.map((question, qIndex) => (
                                                    <div
                                                      key={qIndex + question.sub_rule_id}
                                                      className={style.questionCard}
                                                      style={{ marginTop: '0px', paddingTop: '15px' }}
                                                    >
                                                      <div className={style.changeCheckbox} key={removeId.length}>
                                                        <div className={style.loftQuestionTitle}>
                                                          {!isView && (
                                                            <label className="custom-checkbox" aria-label="checkbox">
                                                              <input
                                                                type="checkbox"
                                                                checked={removeId?.subrule?.includes(
                                                                  question.sub_rule_id
                                                                )}
                                                                onChange={(e) =>
                                                                  handleRemoveIds(
                                                                    question.sub_rule_id,
                                                                    'subrule',
                                                                    e.target.checked
                                                                  )
                                                                }
                                                              />
                                                              <span className="checkmark"></span>
                                                            </label>
                                                          )}
                                                          <h4
                                                            className={style.questionTitle}
                                                            style={{
                                                              marginLeft: '6px',
                                                              marginBottom: '10px',
                                                              marginTop: '5px',
                                                            }}
                                                          >
                                                            Question {qIndex + 1}
                                                          </h4>
                                                        </div>
                                                        <div className={style.answerInput}>
                                                          <div
                                                            className={style.changesEvent}
                                                            style={{ margin: '0 8px' }}
                                                          >
                                                            <input
                                                              type="text"
                                                              style={{
                                                                display: 'inline',
                                                                width: '20%',
                                                                border: 'none',
                                                                background: 'transparent',
                                                              }}
                                                              value={question?.correct_answer_marks}
                                                              disabled
                                                            />
                                                            <input
                                                              type="text"
                                                              style={{
                                                                display: 'inline',
                                                                width: '20%',
                                                                border: 'none',
                                                                background: 'transparent',
                                                              }}
                                                              value={question?.incorrect_answer_marks}
                                                              disabled
                                                            />
                                                          </div>
                                                          {!isView &&
                                                            (onAdd || (isEdit && testDetails?.remove_rules)) && (
                                                              <div className={style.ruleMiddleContainerRight}>
                                                                <img
                                                                  src={ruleDelete}
                                                                  className={style.iconInfo}
                                                                  style={{ margin: '0px 0px 0px 8px' }}
                                                                  alt="delete"
                                                                  onClick={() =>
                                                                    deleteRule(
                                                                      question.sub_rule_id,
                                                                      rule.format,
                                                                      rule.rule_id
                                                                    )
                                                                  }
                                                                />
                                                              </div>
                                                            )}
                                                        </div>
                                                      </div>
                                                      <p
                                                        className={style.questionInfo}
                                                        style={{ margin: '0px', marginBottom: '15px' }}
                                                      >
                                                        <span className={style.labelTitle}>Question Type:</span>{' '}
                                                        <span className={style.labelText}>{question.type}</span>
                                                        <span className={style.sepearator}> | </span>
                                                        <span className={style.labelTitle}>LOD:</span>{' '}
                                                        <span className={style.labelText}>{question.lod}</span>
                                                      </p>
                                                      <div className={style.tags} style={{ marginBottom: '5px' }}>
                                                        {question?.primary_tags?.map((tag, index) => (
                                                          <span key={`${index}-${tag}`} className={style.tag}>
                                                            {tag?.primary_tag?.slug}
                                                          </span>
                                                        ))}
                                                      </div>
                                                    </div>
                                                  ))}
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                    return !isView && ruleContent ? (
                                      <Draggable
                                        key={rule?.order}
                                        draggableId={`rule-${groupsButton}-${sectionButton}-${index}`}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className={`${style.ruleCard} ${style.sectionRuleCard}`}
                                          >
                                            {ruleContent}
                                          </div>
                                        )}
                                      </Draggable>
                                    ) : (
                                      <div key={rule?.order} className={`${style.ruleCard} ${style.sectionRuleCard}`}>
                                        {ruleContent}
                                      </div>
                                    );
                                  })}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </div>
                          {!isView && (
                            <footer className={`${style.sectionFooter} ${isView ? style.isViewMainContainer : ''}`}>
                              <div className={style.footer_content}>
                                <span style={{ fontWeight: '500' }}>Selected Items</span>
                                <span>
                                  {sectionItem?.footer_selected_rules?.length
                                    ? sectionItem.footer_selected_rules.reduce((sum, rule) => sum + rule.count, 0)
                                    : 0}
                                  <b style={{ color: '#8E9EAB' }}>
                                    {' '}
                                    /{' '}
                                    {sectionItem?.rules?.reduce(
                                      (total, rule) =>
                                        rule.format === 1
                                          ? total + (rule.sub_rules ? rule.sub_rules.length : 0)
                                          : total + 1,
                                      0
                                    )}
                                  </b>
                                </span>
                              </div>

                              <div
                                className={`${style.footer_content_mid} ${style.footer_content_start}`}
                                style={{ marginLeft: '0px' }}
                              >
                                {sectionItem?.footer_selected_rules?.length > 0 ? (
                                  sectionItem?.footer_selected_rules.map((item) => (
                                    <div key={item.ruleId} className={style.closeIds}>
                                      {item.label} {item.ruleFormat === 1 && `(${item.count})`}
                                    </div>
                                  ))
                                ) : (
                                  <p>No rules selected</p>
                                )}
                              </div>

                              <div className={style.footer_content_right}>
                                {!isView && (
                                  <>
                                    {(onAdd || (isEdit && testDetails?.remove_rules)) && (
                                      <span className={style.footerDeleteLabel} onClick={() => deleteMultiRule()}>
                                        Delete Selected
                                      </span>
                                    )}
                                    <div
                                      className={`${style.drop_score} ${style.markingLogic}`}
                                      style={{ marginRight: '10px' }}
                                      onClick={() => OpenMarkingLogic()}
                                    >
                                      Set Marking Logic &nbsp;
                                      <svg
                                        width="26"
                                        style={{
                                          rotate: markingLogicStatus ? '' : '180deg',
                                        }}
                                        height="24"
                                        viewBox="0 0 26 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clipPath="url(#clip0_1445_47115)">
                                          <path
                                            d="M5.01822 16.0469L11.7264 9.52687C12.5186 8.75687 13.815 8.75687 14.6072 9.52687L21.3154 16.0469"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeMiterlimit="10"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_1445_47115">
                                            <rect x="0.820312" width="24.6927" height="24" rx="12" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                  </>
                                )}
                                <div
                                  className={style.logics_input}
                                  style={{
                                    display: markingLogicStatus ? 'block' : 'none',
                                  }}
                                >
                                  <div className={style.new} onClick={() => AddNewScore()}>
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                        stroke="#00ABFB"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M7.5 12H16.5"
                                        stroke="#00ABFB"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M12 16.5V7.5"
                                        stroke="#00ABFB"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    &nbsp; New Scoring Logic
                                  </div>
                                  <div className={style.QuasiScoring}>
                                    {markingLogic?.map((items, i) => (
                                      <div key={i} className={style.inputs} style={{ padding: '8px 0px' }}>
                                        <input
                                          type="radio"
                                          key={items}
                                          id={i}
                                          name="logic"
                                          style={{ margin: '0px 10px' }}
                                          onClick={() => SelectedMarkingLogic(items)}
                                        />
                                        <input
                                          onChange={(e) => handleCorrectAnswerChange(e, i)}
                                          type="number"
                                          className={style.inputsNumber}
                                          style={{
                                            display: 'inline',
                                            width: '28%',
                                            border: 'none',
                                            marginRight: '8px',
                                            background: 'transparent',
                                          }}
                                          value={items?.correct_answer_marks}
                                        />
                                        <input
                                          onKeyDown={(event) => {
                                            if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                              event.preventDefault();
                                            }
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                          autoComplete="off"
                                          onChange={(e) => handleInCorrectAnswerChange(e, i)}
                                          type="number"
                                          style={{
                                            display: 'inline',
                                            width: '28%',
                                            border: 'none',
                                            background: 'transparent',
                                          }}
                                          value={items?.incorrect_answer_marks}
                                        />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </footer>
                          )}
                        </div>
                      )}
                      <div style={{ marginTop: '1rem' }} className={style.performBT}>
                        <button
                          className={` ${style.btOne} ${style.common}`}
                          style={{ pointerEvents: 'all' }}
                          onClick={() => dispatch(changeAdd_test_screen(0))}
                        >
                          Back
                        </button>
                        {!isView && (
                          <button
                            className={` ${style.btTwo} ${style.common}`}
                            onClick={() => {
                              isEdit
                                ? dispatch(Edit_Section_Test(body, testDetails?.id, testType, toast, organizationId))
                                : dispatch(
                                    Add_Section_Test(
                                      body,
                                      testCreationId ?? testDetails?.id,
                                      testType,
                                      toast,
                                      organizationId
                                    )
                                  );
                            }}
                          >
                            Save & Continue
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            ))}
        </div>
      </DragDropContext>
      {modal ? (
        <BrowsingQuestionLoft
          setBankId={setQuestionBankId}
          handleOpenPreview={handleOpenModal}
          isPublished={testDetails?.is_published}
          isEdit={isEdit}
          testDetails={testDetails}
          onAdd={onAdd}
          isView={isEditandPublished || isView}
          setModal={(val) => {
            setModal(val);
            if (!val) {
              setIsEditandPublished(false);
            }
          }}
          numberOfQuesAddedQuestion={body.groups[groupsButton].sections[sectionButton].section_total_question_added}
          totalQuestion={body.groups[groupsButton].sections[sectionButton].no_of_questions}
          testId={testDetails?.id ?? testCreationId}
          ruleId={ruleId}
          ruleFormat={format}
          groupName={body.groups[groupsButton].group_name}
          groupId={body.groups[groupsButton].group_id}
          testType={testType}
          sectionName={body.groups[groupsButton].sections[sectionButton].section_name}
          sectionId={body.groups[groupsButton].sections[sectionButton].section_id}
          correctAnswerMarks={body.groups[groupsButton].sections[sectionButton].correct_answer_marks}
          inCorrectAnswerMarks={body.groups[groupsButton].sections[sectionButton].incorrect_answer_marks}
          sectionRuleListing={sectionRuleListing}
        />
      ) : (
        ''
      )}
      {isPreviewopen && (
        <PreviewModal
          onEdit={handleEdit}
          questionAccess={questionAccess}
          selectedQuestion={selectedQuestion}
          isOpen={isPreviewopen}
          onClose={handleCloseModal}
          setIsDuplicateModalOpen={setIsModalOpen}
          setModalData={setModalData}
          modalData={modalData}
          setIsDuplicatePreview={setIsDuplicatePreview}
          iframeSrc="/question-content-url"
        />
      )}
      {isModalOpen && (
        <QuestionListModal
          isOpen={isModalOpen}
          onClose={closeModal}
          onConfirm={onConfirmDuplicate}
          data={modalData} // Pass modalData to the modal
          isDuplicatePreview={isDuplicatePreview}
        />
      )}
      {modalMedium && (
        <div className={` ${style.rulesEditquestionLockModal}`}>
          <LockModal
            modalData={modalModalData}
            forwardButton={() => navigate('/edit-question', { state: questionItem })}
            modalMedium={modalMedium}
            closeModalMedium={closeModalMedium}
          />
        </div>
      )}
    </div>
  );
};

LoftSections.propTypes = {
  getData: PropTypes.any,
  isEdit: PropTypes.any,
  isView: PropTypes.any,
  onAdd: PropTypes.any,
};

export default LoftSections;
